module.exports = __webpack_public_path__ + "media/images/angel-investors-4ddbcf0cdb76b8d1effdd409e610a56c.png";